/**
 * WordPress dependencies
 */
import { useSelect } from '@wordpress/data';
import {
	store as blocksStore,
} from '@wordpress/blocks';
import {
	useBlockProps,
	store as blockEditorStore,
	__experimentalBlockVariationPicker, // eslint-disable-line
} from '@wordpress/block-editor';
import { Button, Placeholder } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import { useBlockNameForPatterns } from './utils';

export default function SelectPlaceholder( {
	attributes,
	clientId,
	name,
	openPatternSelectionModal,
} ) {
	const blockProps = useBlockProps();
	const blockNameForPatterns = useBlockNameForPatterns(
		clientId,
		attributes,
		name
	);

	const { blockType, activeBlockVariation, hasPatterns } = useSelect(
		( select ) => {
			const { getActiveBlockVariation, getBlockType } = select( blocksStore );
			const { getBlockRootClientId, getPatternsByBlockTypes } = select( blockEditorStore );
			const rootClientId = getBlockRootClientId( clientId );
			return {
				blockType: getBlockType( name ),
				activeBlockVariation: getActiveBlockVariation( name, attributes ),
				hasPatterns: !! getPatternsByBlockTypes(
					blockNameForPatterns,
					rootClientId
				).length,
			};
		},
		[ name, blockNameForPatterns, clientId, attributes ]
	);
	const icon =
		activeBlockVariation?.icon?.src ||
		activeBlockVariation?.icon ||
		blockType?.icon?.src;

	const label = activeBlockVariation?.title || blockType?.title;

	return (
		<div { ...blockProps }>
			<Placeholder
				icon={ icon }
				label={ label }
				instructions={ __(
					'Choose a pattern for the portal & kickstart your community building journey.',
					'suredash'
				) }
			>
				{ !! hasPatterns && (
					<Button
						variant="primary"
						onClick={ openPatternSelectionModal }
					>
						{ __( 'Choose', 'suredash' ) }
					</Button>
				) }
			</Placeholder>
		</div>
	);
}
